import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {ButtonControl} from '../../../models/uiArtefakt';
import {ButtonCommandService} from '../../../services/button-command.service';
import {NgForm} from '@angular/forms';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {Dokument} from '../../../models/dokument';
import {TrackingService} from '../../../services/tracking.service';
import {ShellConfigService} from '../../../services/shell-config.service';
import {TrackingAktion} from '../../../models/enumTracking';
import {Notification, NotificationService} from '@lv1871/core';

@Component({
    selector: 'lv-download-button',
    templateUrl: './download-button.component.html',
    styleUrls: ['./download-button.component.scss'],
    standalone: false
})
export class DownloadButtonComponent implements OnInit, AfterViewInit {

  @Input()
  public uiDokumentliste: Dokument[];

  @Input()
  public downloadVerpflichtend: boolean = false;

  @Output()
  public successfullyDownloaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public isDisabled: boolean = false;
  public isDownloaded: boolean = false;
  public loading: boolean;

  private _uiArtefakt: ButtonControl;

  constructor(
              private _commandService: ButtonCommandService,
              public _tracker: TrackingService,
              public _shellConfigService: ShellConfigService,
              private _renderer: Renderer2,
              private _element: ElementRef,
              private _notificationService: NotificationService) {
  }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
  }

  onCommand() {
    this.trackDownloadButton();
    if (!this.downloadVerpflichtend && this.uiDokumentliste?.length > 0) {
      const selected = this.uiDokumentliste.filter(dokument => !!dokument.selected);
      if (selected.length > 0) {
        this._handleDownload();
      } else {
        const notification = new Notification(
            'Alert', 'Danger', '',
            'Bitte wählen Sie mindestens 1 Dokument aus', true, null);
        this._notificationService.addNotification(notification);
      }
    } else {
      this._handleDownload();
    }
  }

  private _handleDownload() {
    this.loading = true;
    this.isDownloaded = false;
    this._commandService.handleCommand(this._uiArtefakt, this.uiDokumentliste).subscribe(_ => {
      this.loading = false;
      this.isDownloaded = true;
      this.successfullyDownloaded.emit(true);
    });
  }

  private trackDownloadButton() {
    if (this.uiArtefakt.FeldnameTracking) {
      this._tracker.trackEvent(this.uiArtefakt.Command, TrackingAktion.T_BUTTON, this.uiArtefakt.FeldnameTracking);
    }
  }
}
